var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#1B1F3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.167 26.6667C27.609 26.6667 28.0329 26.4911 28.3455 26.1785C28.6581 25.866 28.8337 25.442 28.8337 25V16.6667C28.8337 16.2246 28.6581 15.8007 28.3455 15.4882C28.0329 15.1756 27.609 15 27.167 15H20.5837C20.3049 15.0027 20.0299 14.9355 19.7839 14.8045C19.5379 14.6735 19.3286 14.4828 19.1753 14.25L18.5003 13.25C18.3486 13.0196 18.142 12.8304 17.8991 12.6995C17.6562 12.5686 17.3846 12.5 17.1087 12.5H13.8337C13.3916 12.5 12.9677 12.6756 12.6551 12.9882C12.3426 13.3007 12.167 13.7246 12.167 14.1667V25C12.167 25.442 12.3426 25.866 12.6551 26.1785C12.9677 26.4911 13.3916 26.6667 13.8337 26.6667H27.167Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.3333V23.3333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.8333L20.5 18.3333L23 20.8333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.9ee782e35f90bbc55578c0a4e1fd3047.svg";
export { ForwardRef as ReactComponent };